// src/components/TeamLogo.jsx
// Reusable team logo — shows uploaded image, emoji fallback, or initials
import React from "react";

export function TeamLogo({ imgUrl, emoji, name, color, size = 40, style = {} }) {
  const bg = color ? `${color}22` : "var(--bg2)";
  const border = color ? `1.5px solid ${color}55` : "1.5px solid var(--border)";
  const fontSize = size * 0.48;

  const base = {
    width: size, height: size, borderRadius: "50%",
    background: bg, border,
    display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0, overflow: "hidden",
    ...style,
  };

  if (imgUrl) {
    return (
      <div style={base}>
        <img src={imgUrl} alt={name || "team"} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </div>
    );
  }

  if (emoji) {
    return (
      <div style={base}>
        <span style={{ fontSize }}>{emoji}</span>
      </div>
    );
  }

  const initials = (name || "?").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div style={{ ...base, color: color || "var(--text-dim)", fontWeight: 800, fontSize: size * 0.35, fontFamily: "'DM Sans', sans-serif" }}>
      {initials}
    </div>
  );
}
